import type { OrdreStatus } from "types/ordre";
import { STATUS_CHIP_STYLES } from "./dropdown/OrdreStatusDropdown";

/**
 * The ordre's status inside a dark hover bubble, as the planning réception tooltip
 * (AppointmentTooltip) shows it — same wording, same chip, so the two plannings read the
 * same way.
 *
 * Read-only here, unlike the réception one: the atelier bubble is `pointer-events-none`
 * (it follows the cursor over a grid you drag blocks on), and the status is changed from
 * the right-click menu on the block itself.
 */
export default function OrdreStatusHint({ status }: { status?: OrdreStatus }) {
  const chip = status ? STATUS_CHIP_STYLES[status] : null;
  if (!chip) return null;
  return (
    <div className="flex flex-col gap-1 mt-2">
      <span className="text-h5 text-neutral-400">Statut de l'OR</span>
      <span
        className="w-fit font-medium"
        style={{ background: chip.bg, color: chip.color, borderRadius: 5, padding: "3px 10px", fontSize: 12, lineHeight: "16px" }}
      >
        {chip.label}
      </span>
    </div>
  );
}
